/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2021] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

import Config from '@config/Config';

export default async function ExternalCACRegistration(data) {
  const jsonData = {
    piv: data.piv,
    username: data.userName,
    password: data.password,
    firstName: data.firstName,
    lastName: data.lastName,
    email: data.email,
    telephone: data.telephone,
    commandIds: data.commandIds
  };

  // Wrapped in a promise only because we need to wrap the jQuery promise.
  // Do not follow this example in other services.
  return new Promise((resolve, reject) => {
    $.ajax({
      headers: { Location: window.location.href },
      url: Config.getExternalCACRegistrationUrl(),
      method: 'POST',
      contentType: 'application/json',
      data: JSON.stringify(jsonData)
    })
      .done((data) => {
        const id = data.match(/(?<=>)\d+(?=<\/ID>)/)?.at(0);
        resolve(id);
      })
      .fail((err) => {
        reject(err);
      });
  });
}
